import { useState, useEffect } from 'react';
import { sourcesService } from '@/services/sources';
import { Source, SourcesQueryParams } from '@/types/sources';
import { useToast } from '@/hooks/use-toast';

export const useSources = (params?: SourcesQueryParams) => {
  const { toast } = useToast();
  const [isLoading, setIsLoading] = useState(true);
  const [sources, setSources] = useState<Source[]>([]);
  const [total, setTotal] = useState(0);
  const [error, setError] = useState<string | null>(null);

  const fetchSources = async (fetchParams?: SourcesQueryParams) => {
    try {
      setIsLoading(true);
      setError(null);
      const response = await sourcesService.getAll(fetchParams || params);
      setSources(response.data || []);
      setTotal(response.total || 0);
    } catch (err: any) {
      const errorMessage = err.message || 'Erro ao carregar fontes';
      setError(errorMessage);
      toast({
        variant: 'error',
        title: 'Erro ao carregar fontes',
        description: errorMessage,
      });
      console.error('Error fetching sources:', err);
      setSources([]);
      setTotal(0);
    } finally {
      setIsLoading(false);
    }
  };

  const syncSources = async () => {
    try {
      setIsLoading(true);
      await sourcesService.syncSources();
      await fetchSources();
      toast({
        title: 'Sincronização concluída',
        description: 'As fontes foram sincronizadas com sucesso.',
      });
    } catch (err: any) {
      const errorMessage = err.message || 'Erro ao sincronizar fontes';
      toast({
        variant: 'error',
        title: 'Erro ao sincronizar fontes',
        description: errorMessage,
      });
      console.error('Error syncing sources:', err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchSources();
  }, [params?.offset, params?.limit, params?.q]);

  return {
    sources,
    total,
    isLoading,
    error,
    refetch: fetchSources,
    syncSources,
  };
}; 